export const LAZY_COMPONENTS = {
    FIVERR_GUIDES: 'fiverr_guides',
    SIGNUP: 'signup',
    VIDEO: 'video',
    FREELANCERS: 'freelancers',
    PERSONALIZED_SECTION_WRAPPER: 'personalized_section_wrapper',
    PRO_BANNER: 'pro_banner',
    AI_BANNER: 'ai_banner',
};

export const LOGGED_OUT_HOMEPAGE_ENTRY_NAMES = {
    LOCALIZED: 'logged_out_homepage_localized',
    MAIN: 'logged_out_homepage',
};
